module.exports = __webpack_public_path__ + "img/double_clock.b823b4a7.png";